// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

//TIPO 5: BOTÖN
//{valor:"", descripcion:"", tipo:5 ,label:"Calcular"},

export default class MonitoreoRespiratorioNged {
    fecha={}
    lista=[
        {
            encabezado:"Datos de filiación",
            datos:[
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
            ]
        },
        {
            encabezado:"(NGED)",
            datos:[
                {valor:"", descripcion:"", tipo:3 ,label:"Nombre substancia química:"},
                {valor:"", descripcion:"", tipo:1 ,label:"Tipo:",data:["Simple","Compuesto"]},
                {valor:"", descripcion:"", tipo:3 ,label:"Nro CAS:"},
                {valor:"", descripcion:"", tipo:1 ,label:"Severidad:",data:["Inocuo","Irritante","Nocivo","Tóxico","Muy Tóxico"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Parte del cuerpo:",data:["una mano","ambas manos o una mano y el antebrazo","ambas manos y el antebrazo o un brazo completo","miembros superiores y el torso o las piernas"]},
                {valor:"", descripcion:"", tipo:1 ,label:"Tiempo de exposición:",data:["Menos de 30 minutos por día","De 30 minutos a 2 horas por día","De 2 a 6 horas por día","Más de 6 horas por día"]},
                {valor:"", descripcion:"", tipo:3 ,label:"NGED:"},
                {valor:"", descripcion:"", tipo:5 ,label:"Calcular", click:3},

            ]
        }
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoDermatológicoNged.js